import React from 'react'
import InputFieldUI from './InputFieldUI'
import MessageUtils from '../../util/MessageUtils'
import './InputName.css'

const InputNameUI = ({context, firstName, lastName,
    // text
    label, messageList, labelKey,
    // behavior
    required, maxLength, autoFocus, disabled, firstNameError, lastNameError,
    // event handlers
    onFirstNameChange, onLastNameChange
  }) =>
  <InputFieldUI className='w_input_name' name='name' required={required} label={label} messageList={messageList} labelKey={labelKey}>
    <input type='text' name='firstName' value={firstName}
      placeholder={messageList ? MessageUtils.getMessageValue(messageList, 'c_first_name') : 'First name'}
      onChange={onFirstNameChange}
      maxLength={40} autoFocus={autoFocus} disabled={disabled}
      className={firstNameError ? 'hasError' : ''}
    />
    <input type='text' name='lastName' value={lastName}
      placeholder={messageList ? MessageUtils.getMessageValue(messageList, 'c_last_name') : 'Last name'}
      onChange={onLastNameChange}
      maxLength={40} disabled={disabled}
      className={lastNameError ? 'hasError' : ''}
    />
  </InputFieldUI>

export default InputNameUI
